import type { IRequestConfig } from '@types'
import type { IRogue } from '../services/RogueTypes'

export interface PdfResponse {
  blob: Blob | null;
  url: string | null;
}

/**
 *
 * @param url
 * @param method
 * @param body
 * @param headers
 * @param rogue
 */
export async function getPdfDocument(
  url: string,
  method: IRequestConfig['method'] = 'POST',
  body = {},
  headers = {},
  rogue: IRogue
): Promise<PdfResponse> {
  let blob: Blob | null = null
  let blobUrl: string | null = null

   
  const response = await rogue.fetch<BlobPart>(url, method, body, headers, 'blob')

  if (response && !rogue.ssr) {
    const URL = window.URL || window.webkitURL
    blob = new Blob([response], { type: 'application/pdf' })
    blobUrl = URL.createObjectURL(blob)
  }

  return { blob, url: blobUrl }
}
